"use client";

import { useEffect } from "react";

/**
 * Registers the service worker for offline support.
 * Only registers in production to avoid dev-mode caching issues.
 */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      process.env.NODE_ENV === "production"
    ) {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        // SW registration failed — silent in production
      });
    }
  }, []);

  return null;
}
